// extracted by mini-css-extract-plugin
module.exports = {"action_color":"CustomFooter_action_color__2i-fk","text_cta":"CustomFooter_text_cta__nM6dz","info":"CustomFooter_info__24Gbv","infoIcon":"CustomFooter_infoIcon__YAIFP"};